import { stripDownPhoneInput } from 'utils/regex'
import { getItem } from 'utils/localstorage'
import { propOr, startsWith } from 'ramda'

export function isValidUKPhoneNumber(phoneNumber) {
  const isBahrain = propOr('GBR', 'country_code', getItem('userData')) === 'BHR'
  const isOman = propOr('GBR', 'country_code', getItem('userData')) === 'OMN'
  const isUAE = propOr('GBR', 'country_code', getItem('userData')) === 'ARE'
  const unformattedNumber = stripDownPhoneInput(phoneNumber)
  const isBahrainOmanUAE = isBahrain || isOman || isUAE
  const ukValidationPass =
    (unformattedNumber.length === 11 && startsWith('0', unformattedNumber)) ||
    (unformattedNumber.length === 10 &&
      (!startsWith('0', unformattedNumber) ||
        startsWith(
          '0',
          unformattedNumber || startsWith('00', unformattedNumber),
        )))
  if (isBahrainOmanUAE) {
    // BHR and OMN should allow 9 digit phone numbers as well
    return unformattedNumber.length === 9 || ukValidationPass
  } else {
    return ukValidationPass
  }
}
